import React from 'react';

import {StandalonePanelContextProvider} from '../../components/Panel/StandalonePanel';
import {SemanticLoader as Loader} from '../../components/utility/InstrumentedLoader';
import {useSingleRunWorkspaceProps} from '../../components/Workspace/singleRunWorkspaceHooks';
import {WorkspaceErrorBoundary} from '../../components/Workspace/WorkspaceErrorBoundary';
import {WorkspaceErrorContent} from '../../components/Workspace/WorkspaceErrorContent';
import {WorkspaceRefsContextProvider} from '../../components/Workspace/WorkspaceRefsContext';
import {
  getDataChecked,
  getError,
  getStatus,
} from '../../state/workspaces/selectors';
import {RunWorkspace} from './RunWorkspace';
import {RUN_VIEW_TYPE, SingleRunWorkspaceWorkspaceProps} from './types';

export const SingleRunWorkspaceWrapper = (
  props: SingleRunWorkspaceWorkspaceProps
) => {
  const singleRunWorkspaceProps = useSingleRunWorkspaceProps(props);

  if (getStatus(singleRunWorkspaceProps) === 'error') {
    return (
      <WorkspaceErrorContent
        error={getError(singleRunWorkspaceProps)}
        viewType={RUN_VIEW_TYPE}
      />
    );
  }
  if (getStatus(singleRunWorkspaceProps) === 'loading') {
    return <Loader name="single-run-workspace-loader" />;
  }
  const data = getDataChecked(singleRunWorkspaceProps);

  return (
    <WorkspaceErrorBoundary
      workspaceStateId={data.workspaceID}
      viewType={RUN_VIEW_TYPE}>
      <WorkspaceRefsContextProvider
        panelBankConfigRef={data.panelBankConfigRef}
        viewRef={data.partRef}
        workspaceSettingsRef={data.workspaceSettingsRef}>
        <StandalonePanelContextProvider>
          <RunWorkspace {...props} {...data} />
        </StandalonePanelContextProvider>
      </WorkspaceRefsContextProvider>
    </WorkspaceErrorBoundary>
  );
};
